import * as React from "react";
import { Resources, useResource } from "Translations/Resources";
import { useDispatch, useSelector } from "react-redux";
import { AccessRoleListItemDto, FilterPropsAccessRole } from "Api/Api";
import { AccessRolesTable } from "Components/Settings/AccessRoles/AccessRolesTable";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { CookieNames } from "Components/Models/CookieNames";
import { RootStateType } from "State/Store";
import { SettingsSubMenu } from "Components/Settings/SettingsSubMenu";
import { getAccessRolesAsync } from "State/AccessRoles/AccessRolesReducer";
import { useTableFiltration } from "Hooks/Tables/useTableFiltration";

export const AccessRolesPage: React.FunctionComponent = _ => {
  const { t } = useResource();
  const dispatch = useDispatch();
  const { isLoading, accessRoles } = useSelector(
    (e: RootStateType) => e.accessRoles,
  );

  const [filtration] = useTableFiltration<
    AccessRoleListItemDto,
    FilterPropsAccessRole
  >({
    tableCode: CookieNames.AccessRoles,
    onDataLoad: filter => {
      dispatch(
        getAccessRolesAsync.request({
          ...filter,
          limit: filter.rows,
          offset: filter.page * filter.rows,
        }),
      );
    },
    defaultOrderBy: "name",
    filters: [
      {
        propertyName: "name",
        defaultValue: "",
      },
      {
        propertyName: "accessRoleCode",
        defaultValue: "",
      },
    ],
  });

  return (
    <AuthenticatedLayout
      title={t(Resources.Settings.Title)}
      breadcrumbItems={[
        {
          name: t(Resources.AccessRoles.Breadcrumb.Title),
        },
      ]}
    >
      <SettingsSubMenu />

      <AccessRolesTable
        accessRoles={accessRoles}
        onPageChange={filtration.onPageChange}
        isLoading={isLoading}
        filter={filtration.getFilterProps()}
        orderBy={filtration.ordering}
        paginationParams={filtration.pagination}
      />
    </AuthenticatedLayout>
  );
};
